import { render, staticRenderFns } from "./TutorialVideos.vue?vue&type=template&id=206a3c0e&scoped=true&"
import script from "./TutorialVideos.vue?vue&type=script&lang=js&"
export * from "./TutorialVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a3c0e",
  null
  
)

export default component.exports